export const SIGN_UP = '/signup'
export const SIGN_UP_ALMOST_DONE = '/signup/almost-done'
export const SIGN_UP_CONFIRM = '/signup/confirm'

const signUpRoutes = [SIGN_UP, SIGN_UP_ALMOST_DONE, SIGN_UP_CONFIRM]

export default signUpRoutes
